
import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"
import "./index.css"
import "bootstrap/dist/css/bootstrap.min.css"
import App from "./App"
import Disclaimer from "./Disclaimer"
import reportWebVitals from "./reportWebVitals"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/en" replace />} />
        <Route path="/:lang" element={<App />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
      </Routes>
    </Router>
  </React.StrictMode>,
)

reportWebVitals()
